import useNextTranslation from 'next-translate/useTranslation';
export var useTranslation = function useTranslation() {
  var ns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'common';
  return useNextTranslation(ns);
};